import {Button} from 'bigdatr-style';
import {Flex} from 'bigdatr-style/layout';
import React from 'react';
import rqApi from '~/api';
import {useRoutes} from '~/app/Router';

export default function AuCreativeInsightLaunch() {
    const submitTrackingForm = rqApi.useSubmitHubspotForm();
    const routes = useRoutes();
    return (
        <>
            <p>
                Say hello to Creative Insights, a new feature to help you speed up competitor
                analysis.
            </p>

            <p>
                Using the power of AI, Creative Insights extracts demographic profiles and core
                messaging strategies within advertising creatives.
            </p>

            <p>
                Each creative we collect will undergo systematic analysis to identify the age and
                gender profiles it targets.
            </p>

            <p>
                When viewing competitor creatives, scroll down and you&apos;ll find the
                comprehensive summary of core value propositions and messaging strategy aimed at
                their target audience.
            </p>

            <p>
                Alongside our recent launch of Creative Index, you can uncover not just what
                competitors run, but when they increase activity, to which target audience and
                demographic.
            </p>

            <p>Creative Insights is now live in Advertising Creative.</p>

            <Flex>
                <Button
                    onClick={() => {
                        submitTrackingForm.mutate(
                            {formId: '9685f2b3-4af7-48d8-8dce-b989e75146b4'},
                            {
                                onSuccess: () => {
                                    routes.exploreCreative.push({
                                        creativeModalId: 'ac7344404286',
                                        creativeListOrderBy: {field: 'lastAppeared', order: 'DESC'}
                                    });
                                }
                            }
                        );
                    }}
                >
                    View Creative Insights
                </Button>
            </Flex>
        </>
    );
}
